<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <v-tabs fixed-tabs v-model="selectedTab">
      <v-tab
        v-on:click.native="submitKarticeInit"
        style="padding-left: 20px; padding-right: 20px"
        >Dnevnik svih operacija</v-tab
      >
      <v-tab
        v-on:click.native="submitKartice2"
        style="padding-left: 20px; padding-right: 20px"
        >Dnevnik tretiranja</v-tab
      >
    </v-tabs>
    <div class="Actions__Content" style="padding: 10px">
      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-menu
                  ref="menuOd"
                  v-model="menuOd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFormattedOd"
                    label="Datum od"
                    readonly
                    @blur="dateOd = parseDate(dateFormattedOd)"
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateOd"
                    no-title
                    @input="menuOd = false"
                    :max="maxDate"
                  ></v-date-picker>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      dateOd = null;
                      $refs.menuOd.save([]);
                    "
                    >Poništi izbor
                  </v-btn>
                </v-menu>
              </v-flex>
              <v-flex
                xs2
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-menu
                  ref="menuDo"
                  v-model="menuDo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFormattedDo"
                    label="Datum do"
                    readonly
                    @blur="dateDo = parseDate(dateFormattedDo)"
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateDo"
                    no-title
                    @input="menuDo = false"
                    :max="maxDate"
                  ></v-date-picker>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      dateDo = null;
                      $refs.menuDo.save([]);
                    "
                    >Poništi izbor
                  </v-btn>
                </v-menu>
              </v-flex>
              <v-flex xs7 pa-2> </v-flex>
              <v-flex xs1 style="text-align: right">
                <v-btn
                  @click="submitKartice"
                  class="AppButtonFilled"
                  style="margin-top: 15px"
                  >Pretraži</v-btn
                >
              </v-flex>
            </v-layout>
            <v-layout v-if="selectedTab === 0">
              <v-flex
                xs11
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="vineyard_select"
                  :items="vineyard_items"
                  item-text="name"
                  item-value="id"
                  :label="labVinograd"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                  ref="element1"
                >
                </v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout v-else>
              <v-flex
                xs4
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="vineyard_select_2"
                  :items="vineyard_items"
                  item-text="name"
                  item-value="id"
                  :label="labVinograd"
                  persistent-hint
                  return-object
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                  ref="element1"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs7
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              ></v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <!-- <download-excel
                :data="json_data"
                :fields="json_fields"
                :meta="json_meta"
                :name="naziv_fajla"
                :param="json_fields"
              >
                <img
                  src="../assets/menuIcons/ico-print.png"
                  title="Štampa dokumenta"
                />
              </download-excel> -->

                <v-btn @click="stampaj2" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
              v-if="selectedTab === 0"
            >
              <v-flex
                xs4
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="operation_type_to_select"
                  :items="operation_type_to_items"
                  item-text="name"
                  item-value="id"
                  label="Tip operacije"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  v-on:change="getAllTipoveOperacija"
                  outlined
                  dense
                  ref="element2"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs7
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
                <v-autocomplete
                  v-model="operation_to_select"
                  :items="operation_to_items"
                  item-text="name"
                  item-value="id"
                  label="Operacija"
                  persistent-hint
                  return-object
                  multiple
                  chips
                  deletable-chips
                  hide-no-data
                  clearable
                  outlined
                  dense
                  ref="element3"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <!-- <download-excel
                :data="json_data"
                :fields="json_fields"
                :meta="json_meta"
                :name="naziv_fajla"
                :param="json_fields"
              >
                <img
                  src="../assets/menuIcons/ico-print.png"
                  title="Štampa dokumenta"
                />
              </download-excel> -->

                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
            v-if="selectedTab === 0"
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                :total-items="ukupnoRedova"
                :rows-per-page-items="listSize"
                style="padding-top: 10px"
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <!-- @click="changeSortKartica(header.value)" -->

                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      items_states
                        .map(function (x) {
                          return x.id;
                        })
                        .indexOf(props.item.id) +
                      1
                    }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ formatDateTime(props.item.date) }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.vineyardName }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ prevediOperacije3lok(props.item.vineyardOperationType) }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                  >
                    {{ props.item.vineyardOperation }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="props.item.blocks.length > 5"
                  >
                    {{ formatTekstaParcelu(props.item.blocks.length) }}
                    <v-tooltip top>
                      <v-icon slot="activator" small class="ml-2" color="teal">
                        info
                      </v-icon>
                      {{ formatRedova(props.item.blocks) }}
                    </v-tooltip>
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else-if="props.item.blocks.length > 0"
                  >
                    {{ formatRedova(props.item.blocks) }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>

                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="props.item.grapeVarieties.length > 2"
                  >
                    {{ formatTekstaSorta(props.item.grapeVarieties.length) }}
                    <v-tooltip top>
                      <v-icon slot="activator" small class="ml-2" color="teal">
                        info
                      </v-icon>
                      <span>
                        <v-container>
                          <div class="DataTable">
                            <v-layout column>
                              <v-flex style="overflow: auto">
                                <v-data-table
                                  :headers="headers_modal_sorta"
                                  :items="props.item.grapeVarieties"
                                  hide-actions
                                  class="elevation-1"
                                  show-select
                                  dense
                                  select-all
                                >
                                  <template
                                    slot="headers"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <th
                                        style="text-align: center; padding: 5px"
                                        v-for="header in props_modal.headers"
                                        :key="header.text"
                                      >
                                        {{ header.text }}
                                      </th>
                                    </tr>
                                  </template>
                                  <template
                                    slot="items"
                                    slot-scope="props_modal"
                                  >
                                    <tr>
                                      <td
                                        style="
                                          text-align: center;
                                          padding-left: 5px;
                                          padding-right: 5px;
                                        "
                                      >
                                        {{ props_modal.item }}
                                      </td>
                                    </tr>
                                  </template>
                                  <template slot="no-data">
                                    <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                                    <v-alert
                                      slot="no-results"
                                      :value="true"
                                      color="primary"
                                      icon="info"
                                      >Nema podataka.</v-alert
                                    >
                                  </template>
                                </v-data-table>
                              </v-flex>
                            </v-layout>
                          </div>
                        </v-container>
                      </span>
                    </v-tooltip>
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else-if="props.item.grapeVarieties.length > 0"
                  >
                    {{ formatRedova(props.item.grapeVarieties) }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="props.item.rows.length > 5"
                  >
                    {{ formatTekstaRed(props.item.rows.length) }}
                    <v-menu
                      open-on-hover
                      top
                      offset-x
                      nudge-right="20"
                      close-delay="100"
                    >
                      <template v-slot:activator="{}">
                        <v-icon
                          slot="activator"
                          small
                          class="ml-2"
                          color="teal"
                        >
                          info
                        </v-icon>
                        <span>
                          <v-container style="background-color: white">
                            <div class="DataTable">
                              <v-layout column>
                                <v-flex style="overflow: auto">
                                  <v-data-table
                                    :headers="headers_modal"
                                    :items="props.item.rows"
                                    hide-actions
                                    class="elevation-1"
                                    show-select
                                    dense
                                    select-all
                                  >
                                    <template
                                      slot="headers"
                                      slot-scope="props_modal"
                                    >
                                      <tr>
                                        <th
                                          style="
                                            text-align: center;
                                            padding: 5px;
                                          "
                                          v-for="header in props_modal.headers"
                                          :key="header.text"
                                        >
                                          {{ header.text }}
                                        </th>
                                      </tr>
                                    </template>
                                    <template
                                      slot="items"
                                      slot-scope="props_modal"
                                    >
                                      <tr>
                                        <td
                                          style="
                                            text-align: center;
                                            padding-left: 5px;
                                            padding-right: 5px;
                                          "
                                        >
                                          {{ props_modal.item }}
                                        </td>
                                      </tr>
                                    </template>
                                    <template slot="no-data">
                                      <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                                      <v-alert
                                        slot="no-results"
                                        :value="true"
                                        color="primary"
                                        icon="info"
                                        >Nema podataka.</v-alert
                                      >
                                    </template>
                                  </v-data-table>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-container>
                        </span>
                      </template>
                    </v-menu>
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else-if="props.item.rows.length > 0"
                  >
                    {{ formatRedova(props.item.rows) }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="props.item.plants > 0"
                  >
                    {{ currencyFormat(props.item.plants) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-if="props.item.surface > 1000"
                  >
                    {{ Math.round(props.item.surface / 100) / 100 }} ha
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else-if="props.item.surface > 0"
                  >
                    {{ Math.round(props.item.surface) / 100 }} ar
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                    "
                    v-else
                  >
                    -
                  </td>
                  <td>
                    <img
                      class="DataTable__Button"
                      title="Pregled dokumenta"
                      src="../assets/icons/zatabele/ico-view.png"
                      alt="ulaz-grozdja"
                      @click="viewItem(props.item, false)"
                    />
                  </td>
                </template>
                <template slot="pageText" slot-scope="item">
                  {{ item.pageStart }} - {{ item.pageStop }} od
                  {{ item.itemsLength }}
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                <v-layout row>
                  <v-flex xs4></v-flex>
                  <v-flex
                    xs2
                    style="
                      text-align: right;
                      padding-right: 10px;
                      padding-top: 23px;
                    "
                  >
                    Redova na stranici:
                  </v-flex>
                  <v-flex xs1 style="max-width: 3%">
                    <v-select
                      v-model="redovaPoStrani"
                      :items="listSize"
                      item-text="text"
                      item-value="value"
                      persistent-hint
                      v-on:change="changeOperation"
                      style="font-size: 14px"
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs2
                    style="padding-top: 23px; padding-left: 10px"
                    v-if="
                      paginationKartica.rowsPerPage * paginationKartica.page <=
                      ukupnoRedova
                    "
                  >
                    {{
                      1 +
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      " - " +
                      paginationKartica.rowsPerPage * paginationKartica.page +
                      " od " +
                      ukupnoRedova
                    }}
                  </v-flex>
                  <v-flex
                    xs2
                    style="padding-top: 23px; padding-left: 10px"
                    v-else
                  >
                    {{
                      1 +
                      paginationKartica.rowsPerPage *
                        (paginationKartica.page - 1) +
                      " - " +
                      ukupnoRedova +
                      " od " +
                      ukupnoRedova
                    }}
                  </v-flex>
                  <v-flex xs2 style="padding-top: 10px; text-align: left">
                    <v-pagination
                      v-model="paginationKartica.page"
                      :length="pages"
                      :total-visible="5"
                    ></v-pagination>
                  </v-flex>
                </v-layout>
              </div>
            </v-flex>
          </v-layout>

          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
            v-else
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="id"
                ref="dTable"
                :pagination.sync="paginationKartica"
                style="padding-top: 10px"
                hide-actions
                expand
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <!-- @click="changeSortKartica(header.value)" -->

                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 10%;
                    "
                    @click="props.expanded = !props.expanded"
                  >
                    {{
                      items_states
                        .map(function (x) {
                          return x.id;
                        })
                        .indexOf(props.item.id) + 1
                    }}
                  </td>
                  <td
                    style="
                      text-align: center;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 20%;
                    "
                    @click="props.expanded = !props.expanded"
                  >
                    {{
                      props.item.phenoPhase !== null &&
                      props.item.phenoPhase !== undefined
                        ? props.item.phenoPhase.name
                        : ""
                    }}
                  </td>

                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 15%;
                    "
                    @click="props.expanded = !props.expanded"
                  >
                    {{ formatDateTime(props.item.date) }}
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 15%;
                    "
                    @click="props.expanded = !props.expanded"
                  >
                    {{
                      props.item.waterVolume !== null
                        ? props.item.waterVolume + " l"
                        : "-"
                    }}
                    
                  </td>
                  <td
                    style="
                      text-align: right;
                      padding-left: 5px;
                      padding-right: 5px;
                      width: 40%;
                    "
                    @click="props.expanded = !props.expanded"
                  >
                    {{ props.item.description }}
                  </td>
                </template>
                <template slot="expand" slot-scope="props">
                  <template>
                    <table class="topics" style="background: #f3f7f4">
                      <tr
                        style="
                          border-bottom: solid;
                          border-width: 1px;
                          border-color: grey;
                        "
                      >
                        <th>Problem</th>
                        <th>Preparat</th>
                        <th
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Količina
                        </th>
                        <th
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Koncentracija
                        </th>
                        <th
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Količina primene
                        </th>
                        <th
                          style="
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          Karenca
                        </th>
                      </tr>
                      <tr
                        v-for="(item, index) in props.item.treatmentDatas"
                        :key="index"
                      >
                        <td style="width: 25%">{{ item.disease }}</td>
                        <td style="width: 25%">{{ item.material }}</td>
                        <td
                          style="
                            width: 15%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{ item.quantity + " " + item.unitOfMeasure }}
                        </td>
                        <td
                          style="
                            width: 15%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            item.concentration !== null
                              ? item.concentration + " %"
                              : "-"
                          }}
                          
                        </td>
                        <td
                          style="
                            width: 15%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                        >
                          {{
                            item.concentrationPerHa +
                            " " +
                            item.unitOfMeasure +
                            "/ha"
                          }}
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-if="item.waitingPeiod !== null"
                        >
                          {{ item.waitingPeiod }} dana
                        </td>
                        <td
                          style="
                            width: 20%;
                            text-align: right;
                            padding-left: 5px;
                            padding-right: 5px;
                          "
                          v-else
                        >
                          -
                        </td>
                      </tr>
                    </table>
                  </template>
                </template>

                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";
import {
  readJSON,
  prevediOperacije3,
  prevediOperacije3SaSrpskog,
  getDateTime,
  daLiJeVinarija,
} from "../helpers/Functions";

import html2pdf from "html2pdf.js";

export default {
  props: ["operationType"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,

    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      headers_states: [
        
      ],
      items_states: [],
      listSize: [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "25", value: 25 },
        { text: "50", value: 50 },
        { text: "100", value: 100 },
        { text: "Svi", value: 1000000 },
      ],
      redovaPoStrani: 25,
      paginationKartica: {
        sortBy: "date",
        rowsPerPage: 25,
        descending: false,
        page: 1,
      },
      ukupnoRedova: 0,
      search: "",
      izabranaStranica: 0,
      operation_to_select: null,
      operation_to_items: [
        { id: 1, name: "Rezidba" },
        { id: 2, name: "Đubrenje" },
        { id: 3, name: "Mašinska obrada" },
        { id: 4, name: "Ručna obrada" },
        { id: 5, name: "Zaštita" },
        { id: 6, name: "Berba" },
        { id: 7, name: "Stanje" },
        { id: 8, name: "Parametri" },
        { id: 9, name: "Sadnja" },
        { id: 10, name: "Krčenje" },
        { id: 11, name: "Naslon" },
      ],
      vineyard_items: [],
      vineyard_select: undefined,
      vineyard_select_2: undefined,
      menuOd: "",
      dateOd: null,
      dateFormattedOd: null,
      menuDo: "",
      dateDo: null,
      dateFormattedDo: null,

      loading: true,
      headers_modal: [
        {
          text: "Izabrani redovi",
          value: "tankNumberInBatch",
          align: "center",
        },
      ],
      headers_modal_sorta: [
        { text: "Izabrane sorte", value: "tankNumberInBatch", align: "center" },
      ],

      datumOdFiter: "",
      datumDoFiter: "",
      vinogradiFilter: "",
      fiterOperacija: "",
      fiterTipoviOperacija: "",
      json_data: [],
      json_fields_type: [],
      json_fields: {
        Rb: "String",
        Datum: "Date",
        Vinograd: "String",
        "Tip operacija": "String",
        Operacija: "String",
        Parcele: "String",
        Sorte: "String",
        Redovi: "String",
        "Broj čokota": "Number",
        Površina: "String",
      },
      operation_type_to_select: null,
      operation_type_to_items: [
        "Mašinska obrada",
        "Ručna obrada",
        "Zaštita",
        "Berba",
        "Stanje",
        "Parametri",
        "Sadnja",
        "Krčenje",
        "Naslon",
        "Rezidba",
        "Đubrenje",
      ],
      selectedTab: 0,
      vinogradFilter: "",
      naslov: "",
      vinarija: true
    };
  },
  computed: {
    pages() {
      if (
        this.paginationKartica.rowsPerPage == null ||
        this.ukupnoRedova == null
      )
        return 0;

      return Math.ceil(this.ukupnoRedova / this.paginationKartica.rowsPerPage);
    },
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
    params(nv) {
      return {
        ...this.paginationKartica,
        query: this.search,
      };
    },
  },
  watch: {
    params: {
      handler(newVal, oldVal) {
        if (this.operationType !== undefined)
          if (
            (newVal.page !== oldVal.page ||
              newVal.rowsPerPage !== oldVal.rowsPerPage ||
              newVal.sortBy !== oldVal.sortBy ||
              newVal.descending !== oldVal.descending) &&
            newVal.sortBy !== ""
          ) {
            this.izabranaStranica = this.paginationKartica.page - 1;

            if (this.vineyard_items.length === 0) this.getVineYards();

            if (this.selectedTab === 0) this.getAllKartice(true);
            else this.getAllKartice2();
          }
      },
      deep: true,
    },
    dateOd(val) {
      this.dateFormattedOd = this.formatDate1(this.dateOd);
    },
    dateDo(val) {
      this.dateFormattedDo = this.formatDate1(this.dateDo);
    },
    operationType: function (val) {
      this.clear();
      this.items_states = [];

      if (val !== null && val !== undefined) {
        this.getVineYards();

        this.selectedTab = 0;
        this.submitKarticeInit();

        // this.setDate();
      }
    },
  },

  methods: {
    currencyFormat(num) {
      let odgovor = "";

      if (num !== undefined)
        odgovor = num
          .toFixed(0) // always two decimal digits
          .replace(".", ",") // replace decimal point character with ,
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 "); // use . as a separator

      return odgovor;
    },
    changeOperation(a) {
      this.paginationKartica.page = 1;

      if (a === 1000000) this.paginationKartica.rowsPerPage = this.ukupnoRedova;
      else this.paginationKartica.rowsPerPage = a;
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.dateOd = [Year, Month, "01"].join("-");
      this.dateDo = [Year, Month, Day].join("-");
    },
    viewItem(item, izmena) {
      item.edit = izmena;
      let akcija = 0;

      if (item.vineyardOperationType === "MACHIN") akcija = 1;
      else if (item.vineyardOperationType === "HAND") akcija = 2;
      else if (item.vineyardOperationType === "FITO") akcija = 3;
      else if (item.vineyardOperationType === "HARVEST") akcija = 4;
      else if (item.vineyardOperationType === "STATE") akcija = 5;
      else if (item.vineyardOperationType === "PARAMETERS") akcija = 6;
      else if (item.vineyardOperationType === "PLANTING") akcija = 7;
      else if (item.vineyardOperationType === "DESTROYING") akcija = 8;

      serverBus.$emit("open_modal", akcija, item.vineyardOperationType, item);
    },
    prevediOperacije3lok(text) {
      return prevediOperacije3(text);
    },
    formatDate13(date) {
      if (typeof date !== "undefined" && date !== null) {
        let lokDate = date.split("T")[0];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        return [day, month, year].join(".");
      } else return "";
    },
    formatTekstaCokot(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
      else tekst = "čokota";

      return tekst;
    },
    formatTekstaRed(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = broj + " reda";
      else tekst = broj + " redova";

      return tekst;
    },
    formatRedova(niz) {
      let tekst = "";

      if (niz.length > 0) {
        niz.forEach(function (entry) {
          tekst = tekst + entry + ", ";
        });

        tekst = tekst.substring(0, tekst.length - 2);
      }

      return tekst;
    },
    formatTekstaSorta(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = broj + " sorte";
      else tekst = broj + " sorti";

      return tekst;
    },
    formatTekstaParcelu(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = broj + " parcela";
      else if (broj === 2 || broj === 3 || broj === 4)
        tekst = broj + " parcele";
      else tekst = broj + " parcela";

      return tekst;
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    // getFieldTextWine(item) {
    //   return `${item.label} ${item.year}`;
    // },
    getAllTipoveOperacija(a) {
      this.operation_to_select = [];

      if (a !== undefined) {
        let _this = this;
        this.operation_to_select = undefined;

        if (a.length === 0) this.getOperations();
        else {
          this.operation_to_items = [];

          a.forEach(function (entry) {
            let prevodOperacije = prevediOperacije3SaSrpskog(entry);

            if (
              prevodOperacije === "MACHIN" ||
              prevodOperacije === "HAND" ||
              prevodOperacije === "TRELLIS"
            )
              _this.$http
                .get(
                  _this.globalServiceLocation +
                    _this.globalPort +
                    "/vineyard_operation/type/" +
                    prevodOperacije,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization:
                        "Bearer  " + localStorage.getItem("user-token"),
                    },
                  }
                )
                .then((response) => {
                  response.data.forEach(function (entry) {
                    _this.operation_to_items.push(entry);
                  });
                })
                .catch((e) => {
                  // // console.log(e.response);

                  if (!e.response) {
                    alert(
                      this.$t("error.message")
                    );
                  } else {
                    if (e.response.status === 401) {
                      _this.$refs.frmtoken
                        .osvezavanjeTokena(
                          localStorage.getItem("user-refresh-token")
                        )
                        .then((result) => {
                          // // console.log(result);
                          // // console.log("Novi token - " + localStorage.getItem("user-token"));

                          _this.$http
                            .get(
                              _this.globalServiceLocation +
                                _this.globalPort +
                                "/vineyard_operation/type/" +
                                prevodOperacije,
                              {
                                headers: {
                                  "Content-Type": "application/json",
                                  Authorization:
                                    "Bearer  " +
                                    localStorage.getItem("user-token"),
                                },
                              }
                            )
                            .then((response) => {
                              response.data.forEach(function (entry) {
                                _this.operation_to_items.push(entry);
                              });
                            })
                            .catch((e) => {
                              // // console.log(e.response);

                              let pomError = readJSON(e.response.data.message);
                              alert(pomError);
                            });
                        });
                    } else {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    }
                  }
                });
          });
        }
      } else this.getOperations();
    },
    submitKartice2() {
      this.vineyard_select_2 = undefined;
      this.$refs.element1.reset();

      this.items_states = [];
      this.json_data = [];

      this.json_fields = {
        "Redni broj": "String",
        "Fenološka faza": "String",
        Datum: "String",
        Problem: "String",
        Preparat: "String",
        "Količina vode": "String",
        Količina: "String",
        Koncentracija: "String",
        "Količina primene": "String",
        Karenca: "String",
        Napomena: "String",
        Potpis: "String",
      };

      this.json_fields_type = [
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
      ];

      this.headers_states = [
        { text: "Rb.", sortable: false },
        {
          text: "Fenološka faza",
          value: "phenoPhase.name",
          align: "center",
          sortable: true,
        },
        {
          text: "Datum",
          value: "date",
          align: "right",
          sortable: true,
        },
        {
          text: "Utrošak vode",
          value: "waterVolume",
          align: "right",
          sortable: true,
        },
        {
          text: "Napomena",
          value: "description",
          align: "right",
          sortable: true,
        },
      ];
    },
    stampaj2() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        if (
          _this.datumOdFiter !== "" ||
          _this.datumDoFiter !== "" ||
          _this.vinogradFilter !== ""
        ) {
          let pomocni_tekst = "";

          pomocni_tekst = pomocni_tekst + this.labVinograd + ": " + _this.vinogradFilter;

          pomocni_tekst = pomocni_tekst + "<br><br>";

          if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
            if (_this.datumOdFiter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Period: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

              if (_this.datumDoFiter !== "")
                pomocni_tekst =
                  pomocni_tekst +
                  " - " +
                  _this.formatDate1(_this.datumDoFiter) +
                  ".";
            } else
              pomocni_tekst =
                pomocni_tekst +
                "Za period do: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = false;
          // var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if ((val === null || val === 0 || val === "") && !isLastElement)
              cellText = document.createTextNode("");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (_this.json_fields_type[pomJ] === "Number") {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          // if (isLastElement) {
          //   poslednjiRed = row;
          // }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        // tbl.style.margin = "20px 0px 0px 70%";
        // tbl.style.width = "30%";

        tbl.style.margin = "20px 0px 0px 495px";
        tbl.style.width = "31%";

        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    getAllKartice2() {
      this.isLoading = true;
      this.naslov = "Knjiga evidencije tretiranja biljaka";

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "&from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      let _this = this;

      let sortiranje = "";
      if (this.paginationKartica.sortBy !== "") {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/vineyard_operation_execution/spraying_diary/" +
        this.vineyard_select_2.id +
        "?";

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      setTimeout(() => {
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              urlLoc +
              strDate +
              strDateDo,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            if (response.data.vineyard !== null) {
              this.vinogradFilter = response.data.vineyard.name;

              this.items_states = response.data.vineyardSprayingExecutions;

              let _this = this;
              this.json_data = [];
              let rbr = 1;

              response.data.vineyardSprayingExecutions.forEach(function (
                entry
              ) {
                let brojac = 0;

                entry.treatmentDatas.forEach(function (e) {
                  let objekat = {
                    "Redni broj": rbr,
                    "Fenološka faza":
                      entry.phenoPhase !== null ? entry.phenoPhase.name : "-",
                    Datum: _this.formatDateTime(entry.date),
                    Problem: "",
                    Preparat: "",
                    "Količina vode":
                      entry.waterVolume !== null
                        ? entry.waterVolume + " l"
                        : " - ",
                    Količina: "",
                    Koncentracija: "",
                    "Količina primene": "",
                    Karenca: "",
                    Napomena: entry.description,
                    Potpis: "",
                  };

                  objekat.Problem = e.disease;
                  objekat.Preparat = e.material;
                  objekat["Količina"] = e.quantity + " " + e.unitOfMeasure;
                  objekat.Koncentracija =
                    e.concentration !== null ? e.concentration + " %" : " - ";
                  objekat["Količina primene"] =
                    e.concentrationPerHa + " " + e.unitOfMeasure + "/ha";
                  objekat.Karenca =
                    e.waitingPeiod !== null ? e.waitingPeiod + " dana" : "";

                  if (brojac !== 0) {
                    objekat["Redni broj"] = "";
                    objekat["Količina vode"] = "";
                    objekat["Fenološka faza"] = "";
                    objekat["Datum"] = "";
                    objekat["Napomena"] = "";
                  }

                  brojac = brojac + 1;

                  _this.json_data.push(objekat);
                });

                rbr = rbr + 1;
              });
            }
            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlLoc +
                          strDate +
                          strDateDo,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        if (response.data.vineyard !== null) {
                          this.vinogradFilter = response.data.vineyard.name;

                          this.items_states =
                            response.data.vineyardSprayingExecutions;

                          let _this = this;
                          this.json_data = [];
                          let rbr = 1;

                          response.data.vineyardSprayingExecutions.forEach(
                            function (entry) {
                              let brojac = 0;

                              entry.treatmentDatas.forEach(function (e) {
                                let objekat = {
                                  "Redni broj": rbr,
                                  "Fenološka faza":
                                    entry.phenoPhase !== null
                                      ? entry.phenoPhase.name
                                      : "-",
                                  Datum: _this.formatDateTime(entry.date),
                                  Problem: "",
                                  Preparat: "",
                                  "Količina vode":
                                    entry.waterVolume !== null
                                      ? entry.waterVolume + " l"
                                      : " - ",
                                  Količina: "",
                                  Koncentracija: "",
                                  "Količina primene": "",
                                  Karenca: "",
                                  Napomena: entry.description,
                                  Potpis: "",
                                };

                                objekat.Problem = e.disease;
                                objekat.Preparat = e.material;
                                objekat["Količina"] =
                                  e.quantity + " " + e.unitOfMeasure;
                                objekat.Koncentracija =
                                  e.concentration !== null
                                    ? e.concentration + " %"
                                    : " - ";
                                objekat["Količina primene"] =
                                  e.concentrationPerHa +
                                  " " +
                                  e.unitOfMeasure +
                                  "/ha";
                                objekat.Karenca =
                                  e.waitingPeiod !== null
                                    ? e.waitingPeiod + " dana"
                                    : "";

                                if (brojac !== 0) {
                                  objekat["Redni broj"] = "";
                                  objekat["Količina vode"] = "";
                                  objekat["Fenološka faza"] = "";
                                  objekat["Datum"] = "";
                                  objekat["Napomena"] = "";
                                }

                                brojac = brojac + 1;

                                _this.json_data.push(objekat);
                              });

                              rbr = rbr + 1;
                            }
                          );
                        }
                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    submitKarticeInit() {
      this.items_states = [];
      this.json_data = [];

      this.headers_states = [
        { text: "Rb." },
        { text: "Datum", value: "date", align: "center", sortable: true },
        { text: this.labVinograd, value: "", align: "center", sortable: false },
        {
          text: "Tip operacija",
          value: "",
          align: "center",
          sortable: true,
        },
        { text: "Operacija", value: "", align: "center", sortable: false },
        { text: "Parcele", value: "", align: "center", sortable: false },
        { text: "Sorte", value: "", align: "center", sortable: false },
        { text: "Redovi", value: "", align: "center", sortable: false },
        { text: this.labBrojCokota, value: "", align: "right", sortable: false },
        { text: "Površina", value: "", align: "right", sortable: false },
        { text: "", value: "", align: "center", sortable: false },
      ]

      this.json_fields = JSON.parse('{"Rb": "String","Datum": "Date","' + this.labVinograd + '": "String","Tip operacija": "String","Operacija": "String","Parcele": "String","Sorte": "String","Redovi": "String","' + this.labBrojCokota + '": "Number","Površina": "String"}');

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "Number",
        "Number",
      ];
    },
    submitKartice() {
      if (this.$refs.form.validate()) {
        this.paginationKartica.page = 1;

        if (this.selectedTab === 0) this.getAllKartice(true);
        else this.getAllKartice2();
      }
    },
    stampaj() {
      if (this.items_states.length > 0) this.getAllKartice(false);
      else this.stampajSve();
    },
    stampajSve() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        if (
          _this.datumOdFiter !== "" ||
          _this.datumDoFiter !== "" ||
          _this.vinogradiFilter !== "" ||
          _this.fiterOperacija !== "" ||
          _this.fiterTipoviOperacija !== ""
        ) {
          let pomocni_tekst = "";

          if (_this.datumOdFiter !== "" || _this.datumDoFiter !== "") {
            if (_this.datumOdFiter !== "") {
              pomocni_tekst =
                pomocni_tekst +
                "Period: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

              if (_this.datumDoFiter !== "")
                pomocni_tekst =
                  pomocni_tekst +
                  " - " +
                  _this.formatDate1(_this.datumDoFiter) +
                  ".";
            } else
              pomocni_tekst =
                pomocni_tekst +
                "Za period do: " +
                _this.formatDate1(_this.datumOdFiter) +
                ".";

            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.vinogradiFilter !== "") {
            pomocni_tekst =
              pomocni_tekst +
              _this.labVinograd + ": " +
              _this.vinogradiFilter.substring(
                0,
                _this.vinogradiFilter.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.fiterTipoviOperacija !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Tip operacije: " +
              _this.fiterTipoviOperacija.substring(
                0,
                _this.fiterTipoviOperacija.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          if (_this.fiterOperacija !== "") {
            pomocni_tekst =
              pomocni_tekst +
              "Operacija: " +
              _this.fiterOperacija.substring(
                0,
                _this.fiterOperacija.length - 2
              );
            pomocni_tekst = pomocni_tekst + "<br>";
          }

          var elementToPrint1 = document.createElement("p");

          elementToPrint1.innerHTML = pomocni_tekst + " <br>";

          elementToPrint1.style.margin = "5px 0px 0px 0px";
          elementToPrint1.style.fontSize = "14px";
          elementToPrint.append(elementToPrint1);
        }

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        // let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var isLastElement = i == _this.json_data.length - 1;

          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            // if((val === null || val === 0 || val === "") && !isLastElement )
            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (_this.json_fields_type[pomJ] === "Number") {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          // if (isLastElement) {
          //   poslednjiRed = row;
          // }

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        // var tbl = document.createElement("table");
        // var tblBody = document.createElement("tbody");

        // tbl.style.margin = "20px 0px 0px 82%";
        // tbl.style.width = "18%";
        // // tbl.setAttribute("border", "thin solid");
        // tbl.style.borderCollapse = "collapse";
        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // tblBody.appendChild(poslednjiRed);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    getVineYards() {
      let url = "";

      url = this.globalServiceLocation + this.globalPort + "/vineyard/all";

      this.$http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          this.vineyard_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(url, {
                      headers: {
                        "Content-Type": "application/json",
                        Authorization:
                          "Bearer  " + localStorage.getItem("user-token"),
                      },
                    })
                    .then((response) => {
                      this.vineyard_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllKartice(paginacija) {
      this.isLoading = true;

      

      let strDate = "";
      if (this.dateOd !== null) {
        strDate = "&from=" + this.dateOd + "T00:00";
        this.datumOdFiter = this.dateOd;
      }

      let strDateDo = "";
      if (this.dateDo !== null) {
        strDateDo = "&to=" + this.dateDo + "T23:59";
        this.datumDoFiter = this.dateDo;
      }

      let _this = this;
      var pom_vineyard_to_select = "";

      this.vinogradiFilter = "";

      if (this.vineyard_select !== undefined && this.vineyard_select !== null) {
        this.vineyard_select.forEach(function (entry) {
          pom_vineyard_to_select =
            pom_vineyard_to_select + "vineyardId=" + entry.id + "&";

          _this.vinogradiFilter = _this.vinogradiFilter + entry.name + ", ";
        });
      }

      var pom_operation_types_to_select = "";
      this.fiterTipoviOperacija = "";

      if (
        this.operation_type_to_select !== undefined &&
        this.operation_type_to_select !== null
      ) {
        this.operation_type_to_select.forEach(function (entry) {
          pom_operation_types_to_select =
            pom_operation_types_to_select +
            "operationType=" +
            prevediOperacije3SaSrpskog(entry) +
            "&";

          _this.fiterTipoviOperacija =
            _this.fiterTipoviOperacija + entry + ", ";
        });
      }

      var pom_operation_to_select = "";
      this.fiterOperacija = "";

      if (
        this.operation_to_select !== undefined &&
        this.operation_to_select !== null
      ) {
        this.operation_to_select.forEach(function (entry) {
          pom_operation_to_select =
            pom_operation_to_select + "operationId=" + entry.id + "&";

          _this.fiterOperacija = _this.fiterOperacija + entry.name + ", ";
        });
      }

      let sortiranje = "";
      if (this.paginationKartica.sortBy !== "") {
        let orderovanje = "";
        if (this.paginationKartica.descending) orderovanje = "desc";
        else orderovanje = "asc";

        sortiranje =
          "sort=" +
          this.paginationKartica.sortBy.replace("documentNumber", "number") +
          "&order=" +
          orderovanje;
      }

      let urlLoc =
        "/vineyard_operation_execution/diary?" +
        pom_operation_to_select +
        pom_vineyard_to_select +
        pom_operation_types_to_select;

      if (
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "?" ||
        urlLoc.substring(urlLoc.length - 1, urlLoc.length) === "&"
      )
        urlLoc = urlLoc + sortiranje;
      else urlLoc = urlLoc + "&" + sortiranje;

      // urlLoc = urlLoc.substring(0, urlLoc.length - 1);

      let urlFinish;

      if (paginacija)
        urlFinish =
          urlLoc +
          strDate +
          strDateDo +
          "&page=" +
          this.izabranaStranica +
          "&offset=" +
          this.paginationKartica.rowsPerPage;
      else urlFinish = urlLoc + strDate + strDateDo + "&page=0&offset=1000000";

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlFinish, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            if (paginacija) this.items_states = response.data.content;

            let _this = this;
            this.json_data = [];
            let rbr = 1;

            response.data.content.forEach(function (entry) {
              let objekat = {
                Rb: rbr,
                Datum: _this.formatDateTime(entry.date),
                Vinograd: entry.vineyardName,
                "Tip operacije": _this.prevediOperacije3lok(
                  entry.vineyardOperationType
                ),
                Operacija: entry.vineyardOperation,
                Parcele: _this.formatRedova(entry.blocks),
                Sorte: _this.formatRedova(entry.grapeVarieties),
                Redovi: _this.formatRedova(entry.rows),
                "Broj čokota": entry.plants > 0 ? entry.plants : "-",
                Površina:
                  entry.surface > 1000
                    ? Math.round(entry.surface / 100) / 100 + " ha"
                    : entry.surface > 100
                    ? Math.round(entry.surface) / 100 + " ar"
                    : "-",
              };

              //entry.executedUnit === null ? entry.executed : entry.executed + ' ' + entry.executedUnit ,

              _this.json_data.push(objekat);

              rbr = rbr + 1;
            });

            this.ukupnoRedova = response.data.totalElements;

            if (!paginacija) this.stampajSve();
            else this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;

              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlFinish,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        if (paginacija)
                          this.items_states = response.data.content;

                        let _this = this;
                        this.json_data = [];
                        let rbr = 1;

                        response.data.content.forEach(function (entry) {
                          let objekat = {
                            Rb: rbr,
                            Datum: _this.formatDateTime(entry.date),
                            Vinograd: entry.vineyardName,
                            "Tip operacije": _this.prevediOperacije3lok(
                              entry.vineyardOperationType
                            ),
                            Operacija: entry.vineyardOperation,
                            Parcele: _this.formatRedova(entry.blocks),
                            Sorte: _this.formatRedova(entry.grapeVarieties),
                            Redovi: _this.formatRedova(entry.rows),
                            "Broj čokota":
                              entry.plants > 0 ? entry.plants : "-",
                            Površina:
                              entry.surface > 1000
                                ? Math.round(entry.surface / 100) / 100 + " ha"
                                : entry.surface > 100
                                ? Math.round(entry.surface) / 100 + " ar"
                                : "-",
                          };

                          //entry.executedUnit === null ? entry.executed : entry.executed + ' ' + entry.executedUnit ,

                          _this.json_data.push(objekat);

                          rbr = rbr + 1;
                        });

                        this.ukupnoRedova = response.data.totalElements;

                        if (!paginacija) this.stampajSve();
                        else this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    getOperations() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/vineyard_operation",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          console.log(response.data);

          this.operation_to_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.operation_to_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    clear() {
      // this.$refs.form.reset();

      // this.datumOdFiter = "";
      // this.datumDoFiter = "";

      this.$refs.element1.reset();

      if (this.$refs.element2 !== undefined) this.$refs.element2.reset();

      if (this.$refs.element3 !== undefined) this.$refs.element3.reset();

      this.setDate();

      this.vinogradiFilter = "";
      this.fiterOperacija = "";
      this.fiterTipoviOperacija = "";
    },
    changeSortKartica(column) {
      if (this.items_states.length > 0)
        if (typeof column !== "undefined")
          if (column !== "funkcije")
            if (this.paginationKartica.sortBy === column) {
              this.paginationKartica.descending =
                !this.paginationKartica.descending;
            } else {
              this.paginationKartica.sortBy = column;
              this.paginationKartica.descending = false;
            }
    },
  },
  mounted() {
    this.clear();
    this.getOperations();
    this.getVineYards();

    this.selectedTab = 1;
    this.selectedTab = 0;

    this.submitKarticeInit();
  },

beforeMount() {
  this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

  if(!this.vinarija){
    this.labVinograd = "Zasad";
    this.labBrojCokota = "Broj biljaka";
    
  }
  else
  {
    this.labVinograd = "Vinograd";
    this.labBrojCokota = "Broj čokota";
  }

  this.naslov = "Dnevnik operacija";

  this.headers_states = [
        { text: "Rb." },
        { text: "Datum", value: "date", align: "center", sortable: true },
        { text: this.labVinograd, value: "", align: "center", sortable: false },
        {
          text: "Tip operacija",
          value: "",
          align: "center",
          sortable: true,
        },
        { text: "Operacija", value: "", align: "center", sortable: false },
        { text: "Parcele", value: "", align: "center", sortable: false },
        { text: "Sorte", value: "", align: "center", sortable: false },
        { text: "Redovi", value: "", align: "center", sortable: false },
        { text: this.labBrojCokota, value: "", align: "right", sortable: false },
        { text: "Površina", value: "", align: "right", sortable: false },
        { text: "", value: "", align: "center", sortable: false },
      ]
},
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 10%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}
</style>